module.exports = __webpack_public_path__ + "img/m-hd.19525c37.webp";